/* eslint-disable react/prop-types */
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { injectIntl, FormattedMessage } from 'react-intl-next';
import { styled } from '@compiled/react';

import { token } from '@atlaskit/tokens';
import { N20, N300 } from '@atlaskit/theme/colors';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const AddCommentContainer = styled.button({
	/* overriding default button styles */
	appearance: 'none',
	width: '100%',
	padding: 0,
	font: 'inherit',
	backgroundColor: token('elevation.surface.overlay', N20),
	display: 'flex',
	border: 'none',
	borderRadius: '3px',
	height: '40px',
	color: token('color.text.subtlest', '#999'),
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	span: {
		display: 'inline-flex',
		alignItems: 'center',
		padding: '10px',
		color: token('color.text.subtle', N300),
	},
	'&:hover': {
		cursor: 'text',
	},
});

const CommentAddPrompt = injectIntl(
	class CommentAddPrompt extends Component {
		constructor() {
			super();
			this._focusButton = this._focusButton.bind(this);
			this.buttonRef = React.createRef();
		}

		componentDidMount() {
			const { autofocusRef = { current: null } } = this.props;

			if (autofocusRef.current) {
				this._focusButton();
				autofocusRef.current = false;
			}
		}

		_focusButton() {
			if (this.buttonRef.current) {
				this.buttonRef.current.focus();
			}
		}

		render() {
			const {
				intl: { formatMessage },
				onClick,
			} = this.props;

			return (
				<AddCommentContainer
					id="addCommentButton"
					data-test-id="add-comment-button"
					title={formatMessage({ id: 'comment.name.tooltip' })}
					onClick={onClick}
					ref={this.buttonRef}
				>
					<FormattedMessage id="quick.comment.placeholder.message" />
				</AddCommentContainer>
			);
		}
	},
);

CommentAddPrompt.displayName = 'CommentSpinner';
CommentAddPrompt.propTypes = {
	/**
	 * React-intl methods
	 */
	intl: PropTypes.object,
	onClick: PropTypes.func,
	autofocusRef: PropTypes.object,
};

export default CommentAddPrompt;
